import React, { FunctionComponent } from 'react';
import { Provider } from 'react-redux';

import { Router } from '../Router';

import { configureStore } from '../../app/store';
import { ErrorBoundary } from 'react-error-boundary';

import '../resources/styles/theme.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { Unauthenticated } from '../pages/ErrorPages/Unauthenticated';
import { Unauthorized } from '../pages/ErrorPages/Unauthorized';
import { InternalServerError } from '../pages/ErrorPages/InternalServerError';
import { Toaster } from 'react-hot-toast';
import { ThemeInjector } from './ThemeInjector';
import * as Sentry from '@sentry/react';

export const App: FunctionComponent = () => {
  const ErrorFallback = () => {
    return (
      <div className="loader">
        <div className="error-container">
          <div className="message-title"> Something went wrong!</div>
          <div className="message-body">
            <div className="message"> Sorry, this app is still in development mode</div>
            <div className="message">
              {'Please, try again '}
              <a className="message" href="/home">
                here
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  try {
    return (
      <Provider store={configureStore()}>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={(error, info) => {
            Sentry.captureException(error, {
              extra: { componentStack: info.componentStack },
            });
          }}
        >
          <ThemeInjector />
          <Toaster position="bottom-right" reverseOrder={false} />
          <Router />
        </ErrorBoundary>
      </Provider>
    );
  } catch (e) {
    console.error(e);
    if (e instanceof Error) {
      Sentry.captureException(e);
      if (e.message === '500 Internal Server Error') {
        return <InternalServerError />;
      }
      if (e.message === '401 Unauthorized') {
        return <Unauthenticated />;
      }
      if (e.message === '403 Unauthorized') {
        return <Unauthorized />;
      }
    }
    return <ErrorFallback />;
  }
};
